export const ListQueryKey = 'noticelist';
export const DetailQueryKey = 'notice';

export const Urls = {
  selectUrl: '/news/list',
  updateUrl: '/news/update',
  deleteUrl: '/news/delete',
  createUrl: '/news/create',
  detailUrl: '/news/detail',
};
